import { useEffect, useState, useCallback } from "react";
import { BannerDto } from "../api/models/AppConfiguration";
import { getAppConfigForBanner } from "../api/appConfigurationsHttpClient";

export const useBannerConfig = () => {
  const [banners, setBanners] = useState<BannerDto[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const loadBanners = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await getAppConfigForBanner();
      setBanners(data);
    } catch (err) {
      console.error("Error fetching app config:", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadBanners();
  }, [loadBanners]);

  useEffect(() => {
    const handler = () => loadBanners();
    window.addEventListener("bannerconfig:invalidate", handler);
    return () => window.removeEventListener("bannerconfig:invalidate", handler);
  }, [loadBanners]);

  return { banners, isLoading, error, loadBanners };
};
